import { useState, useRef, useContext, useEffect } from "react";
import Login from "../Login";
import { MainContext } from "../../AppContext";
import SideBar from "./SideBar";
import { useSidebarCollapsed } from "./useSidebarCollapsed";
import Navbar from "./Navbar";
import CommandMenu from "../CommandMenu";
import AssistantPanel from "../assistant/AssistantPanel";

function Layout({ children }: any) {
  const { token } = useContext(MainContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useSidebarCollapsed();
  const sidebarRef = useRef<HTMLDivElement>(null);

  // Expose the current sidebar width as a CSS variable so sticky bars / footers
  // anywhere in the tree can align with the content area without prop drilling.
  useEffect(() => {
    const apply = () => {
      const isDesktop = window.matchMedia("(min-width: 640px)").matches;
      const offset = isDesktop ? (isCollapsed ? "5rem" : "18rem") : "0px";
      document.documentElement.style.setProperty("--sidebar-offset", offset);
    };
    apply();
    window.addEventListener("resize", apply);
    return () => window.removeEventListener("resize", apply);
  }, [isCollapsed]);

  if (!token) return <Login />;
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <SideBar
        ref={sidebarRef}
        isSidebarOpen={isSidebarOpen}
        isCollapsed={isCollapsed}
        onToggleCollapsed={() => setIsCollapsed((c) => !c)}
      />
      <CommandMenu />
      <AssistantPanel />
      <div
        className={`${
          isCollapsed ? "sm:ml-20" : "sm:ml-72"
        } transition-[margin] duration-200`}
      >
        <div className="pt-20 px-4">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
